import React from 'react'
import styled from 'styled-components/macro'
import useTranslation from 'next-translate/useTranslation'

import { ColorsMap, device, FontSizeMap, FontWeightMap } from '@/utils/Theme'

type Props = {
  name?: string
  position: number
  imageSrc: string
}

const Set = styled.div`
  position: relative;
  padding: 2rem;
  padding-top: 4rem;
  background-color: ${ColorsMap.white};

  > img {
    width: 100%;
  }

  @media (min-width: ${device.tablet}) {
    &:nth-child(odd):last-child {
      grid-column: 1/3;
      width: 50%;
      justify-self: center;
    }
  }
`

const SetTitle = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  padding: 0.5rem 4rem;
  background-color: ${ColorsMap.primary};
  color: ${ColorsMap.white};
  font-size: ${FontSizeMap.xl};
  font-weight: ${FontWeightMap.bold};
  text-transform: uppercase;
  text-align: center;
  transform: translate(-50%, -50%);

  @media (max-width: ${device.tablet}) {
    padding: 0.5rem 2rem;
  }
`

const SpecialOfferSetCard = ({ name, position, imageSrc }: Props) => {
  const { t } = useTranslation('common')

  return (
    <Set>
      <SetTitle>{name || t('set-name', { number: position })}</SetTitle>
      <img src={imageSrc} alt="" />
    </Set>
  )
}

export default SpecialOfferSetCard
